export default {
  title: "Gebietseinkommensbereich",
  client: "Kunde",
  areaType: "Gebietstyp",
  count: "Anzahl",
  price: "Preis",
  create: "Erstellen",
  form: {
    tenantIsRequired: "Bitte wählen Sie einen Mieter aus",
    typeIsRequired: "Bitte wählen Sie einen Typ aus",
    countIsRequired: "Bitte geben Sie eine Anzahl ein",
    amountIsRequired: "Bitte geben Sie einen Betrag ein",
  },
};
